import './Layout.scss';

import { useState } from "react";

import Menu from "../menu/Menu";
import Header from "../header/Header";

const Layout = ({children}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <div className={"layout"}>
            <div className={"layout_container"}>
                <aside className={"layout_menu"}>
                    <Menu onClose={toggleMenu} isOpen={isOpen}/>
                </aside>
                <div className={"layout_content"}>
                    <header className={"layout_header"}>
                        <Header onOpen={toggleMenu}/>
                    </header>
                    <main className={"layout_main"}>
                        {children}
                    </main>
                </div>
            </div>
        </div>
    )
}

export default Layout;